import { loadScriptWithRequireJS, loadScriptWithGlobalExport } from '@wix/thunderbolt-commons'

export function loadModule<T>(url: string, globalName: string, withRequireJs: boolean): Promise<T> {
	return withRequireJs ? loadScriptWithRequireJS<T>(url) : loadScriptWithGlobalExport<T>(url, globalName)
}
